/*
 * Sincronización carrito ↔ grabado — Mundo Patagón
 * -------------------------------------------------
 * El cuchillo y su servicio de grabado son dos líneas distintas, enlazadas por
 * la propiedad `_Grabado para` (mismo valor en ambas: el nombre del cuchillo
 * más una cola al azar que hace única cada compra). El guion bajo la mantiene
 * fuera del checkout y del correo; en el admin sí se lee, y ahí es donde le
 * sirve al taller. Este script corre en la página del carrito y:
 *   - Elimina la línea de grabado si su cuchillo ya no está (huérfano).
 *   - Sincroniza la cantidad del grabado con la del cuchillo.
 *   - Oculta los controles (cantidad / eliminar) de la línea de grabado, para
 *     que solo se controle desde el cuchillo.
 */
(function () {
  const GRABADO_HANDLES = ['grabado-5000', 'grabado-9900'];
  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let syncing = false;

  const isGrabado = (item) => GRABADO_HANDLES.indexOf(item.handle) !== -1;
  // Se sigue leyendo el nombre viejo como respaldo: un carrito armado antes de
  // este cambio seguiría abierto en el navegador del cliente, y sin esto sus
  // líneas de grabado quedarían huérfanas y se borrarían solas.
  const tokenOf = (item) =>
    item.properties && (item.properties['_Grabado para'] || item.properties._grabado_id);

  async function getCart() {
    const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function changeLine(key, quantity) {
    await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }

  function hideGrabadoControls() {
    document.querySelectorAll('.cart-item').forEach((row) => {
      const link = row.querySelector('a[href*="/products/grabado-"]');
      if (!link) return;
      const qtyCell = row.querySelector('.cart-item__quantity');
      if (qtyCell) qtyCell.style.visibility = 'hidden';
    });
  }

  async function sync() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await getCart();
      const items = cart.items || [];

      // Cantidad de cada cuchillo por token.
      const knifeQtyByToken = {};
      items.forEach((it) => {
        const t = tokenOf(it);
        if (t && !isGrabado(it)) knifeQtyByToken[t] = it.quantity;
      });

      let changed = false;
      for (const it of items) {
        if (!isGrabado(it)) continue;
        const t = tokenOf(it);
        const knifeQty = t ? knifeQtyByToken[t] : undefined;
        if (knifeQty === undefined) {
          await changeLine(it.key, 0); // huérfano → eliminar
          changed = true;
        } else if (it.quantity !== knifeQty) {
          await changeLine(it.key, knifeQty); // sincronizar cantidad
          changed = true;
        }
      }

      if (changed) {
        window.location.reload();
        return;
      }
      hideGrabadoControls();
    } catch (err) {
      console.error('[grabado] Error sincronizando el carro', err);
    } finally {
      syncing = false;
    }
  }

  function init() {
    sync();
    // El tema re-renderiza el carro por AJAX al cambiar cantidades; re-sincronizamos.
    const container = document.querySelector('#main-cart-items, cart-items');
    if (container) {
      const observer = new MutationObserver(() => {
        clearTimeout(window.__grabadoSyncT);
        window.__grabadoSyncT = setTimeout(sync, 300);
      });
      observer.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
